export const ERROR_MESSAGE_SENDER_NAME = 'Please enter a valid name.';
export const ERROR_MESSAGE_RECIPIENTS_EMAIL = (
  'Please enter a valid email address.'
);
export const ERROR_MESSAGE_EMAIL_MESSAGE = 'Please enter a valid message.';

export const RECIPEINTS_EMAIL_SEPARATOR = /\s?,\s?/;
